import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import sharedApisFormattedResponses from 'api/ResponseFormats/Reporting/Overview/SharedDetails'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

export const sharedDetailsEndpoints = {
  getSharedData: async () => {
    return axiosCommonReq({ transformReqConfig: true }).get(
      '/reporting/shared_dashboard_link',
    )
  },
  updateSharedData: async (params: number) => {
    return axiosCommonReq({ transformReqConfig: true }).post(
      '/reporting/shared_dashboard_link',
      {
        saved_filter_id: params,
      },
    )
  },
  deleteLinkData: async (id: number) => {
    return axiosCommonReq().delete(`/reporting/shared_dashboard_link/${id}`)
  },
  updatePasswordData: async (params: any = {}) => {
    return axiosCommonReq({ transformReqConfig: true }).patch(
      `/reporting/shared_dashboard_link/${params.sharedId}`,
      {
        is_password_enabled: params.is_password_enabled,
      },
    )
  },
  logDetails: async (id: number) => {
    return axiosCommonReq({ transformReqConfig: true }).post(
      `/reporting/shared_dashboard_link/${id}/log_share_activity`,
    )
  },
}

const {
  updateSharedData,
  deleteLinkData,
  updatePasswordData,
  logDetails,
  getSharedData,
} = sharedDetailsEndpoints
const {
  sharedFormattedResponse,
  passwordFormattedResponse,
  linkFormattedResponse,
} = sharedApisFormattedResponses

const sharedDetailsApi = {
  getSharedData: () => {
    return apiWrapper({
      endPoint: getSharedData,
      responseFormat: linkFormattedResponse,
      errorFailureAction: handleStatus500,
    })
  },
  updateSharedData: (params: any) =>
    apiWrapper({
      endPoint: updateSharedData,
      params,
      responseFormat: sharedFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  deleteLinkdData: (params: any) =>
    apiWrapper({
      endPoint: deleteLinkData,
      params,
      errorFailureAction: handleStatus500,
    }),
  updatePasswordData: (params: any) =>
    apiWrapper({
      endPoint: updatePasswordData,
      params,
      responseFormat: passwordFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  logDetails: (params?: any) =>
    apiWrapper({
      endPoint: logDetails,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default sharedDetailsApi
